module.exports = __webpack_public_path__ + "static/media/Settings.cdf6ea2d.svg";